import AdAccount from '@/entities/AdAccount';
import BaseEntity from '@/entities/BaseEntity';
import Brand from '@/entities/Brand';
import ConnectedProfile from '@/entities/ConnectedProfile';
import SourceProfile from '@/entities/SourceProfile';
import Subscription from '@/entities/Subscription';
import User from '@/entities/User';

export default class Company extends BaseEntity {
  id = null;
  name = '';
  required_2fa = false;
  enabled_manual_run = false;
  connected_profiles = [];
  source_profiles = [];
  ad_accounts = [];
  brands = [];
  managed_companies = [];
  has_manager_company = false;
  is_demo = false;
  is_shoprenter = false;
  has_shoprenter_charge = false;
  owner = null;
  contact_phone = '';

  start_of_subscription = null;
  last_payment_is_incomplete = false;

  brand_count = null;
  max_brands = null;

  current_subscription = null;
  paid_subscription = null;
  creator_credits = null;

  next_payment_date = null;
  grace_period_end_date = null;
  feature_managed_account_cancellable_at = null;
  managed_brand_ids = [];
  vat_rate = null;
  billing_first_name = '';
  billing_last_name = '';
  billing_company = '';
  billing_vat_number = '';
  billing_country = '';
  billing_zip = '';
  billing_city = '';
  billing_address = '';
  billing_email = '';
  timezone = 'UTC';
  created_at = new Date();
  deleted_at = null;

  _entityFields = {
    current_subscription: Subscription,
    paid_subscription: Subscription,
    owner: User,
  };

  _entityArrayFields = {
    ad_accounts: AdAccount,
    brands: Brand,
    source_profiles: SourceProfile,
    connected_profiles: ConnectedProfile,
    managed_companies: Company,
  };

  constructor(rawData) {
    super();
    if (rawData?.deleted_at && rawData.name && !rawData.name.startsWith('[Deleted]')) {
      rawData.name = `[Deleted] ${rawData.name}`;
    }
    this.updateWith(rawData);
  }

  updateWith(newValues) {
    if (!super.updateWith(newValues)) {
      return;
    }

    if (this.next_payment_date && typeof this.next_payment_date === 'string') {
      this.next_payment_date = new Date(this.next_payment_date);
    }
    if (this.grace_period_end_date && typeof this.grace_period_end_date === 'string') {
      this.grace_period_end_date = new Date(this.grace_period_end_date);
    }
    if (this.feature_managed_account_cancellable_at && typeof this.feature_managed_account_cancellable_at === 'string') {
      this.feature_managed_account_cancellable_at = new Date(this.feature_managed_account_cancellable_at);
    }
  }

  updateAdAccount(newValues) {
    for (const adAccount of this.ad_accounts) {
      if (adAccount['id'] === newValues['id']) {
        adAccount.updateWith(newValues);
        break;
      }
    }
  }

  get usedAssetsCount() {
    const numberOfConnectedSourceProfiles = this.source_profiles.filter(entity => entity.deleted_at === null).length;
    const numberOfConnectedAdAccounts = this.ad_accounts.filter(entity => entity.deleted_at === null).length;

    return numberOfConnectedSourceProfiles + numberOfConnectedAdAccounts;
  }
}
